module.exports = __webpack_public_path__ + "img/Drag.70ff2816.svg";